import styled from 'styled-components';
import { Breakpoint } from '../../styles/constants';
import { StyledButton, StyledLinkButton } from './StyledButtons';

export const ButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  ${StyledButton}, ${StyledLinkButton} {
    margin-bottom: 10px;
  }

  ${Breakpoint.MEDIUM} {
    flex-direction: row;

    ${StyledButton}, ${StyledLinkButton} {
      width: auto;
      margin-right: 10px;
    }

    ${StyledButton}:last-child, ${StyledLinkButton}:last-child {
      margin-right: 0;
    }
  }
`;
